




































import Vue from "vue";
import Vuex from "vuex";
import { Component, Prop } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import { AppConstants as _app } from "@/shared/app.constants";
import DataTableComponents from "@/components/App/Assets/Card/Body/CardType/DataTable/SimpleDataTable.vue";
import { http } from "@/shared/https";
import { Workspace } from "@/entities";

/*
 * Component's properties and events
 */
@Component({
  components: {
    DataTableComponents,
  },
})
export default class CommiunicationGridComponent extends Vue {
  @Prop() items!: any;
  appStatus: any = _app.applicationStatus;
  editableStatus: any = _app.applicantEdiatableStatus;
  filterByKey = '';

  get appItems() {
    return this.items;
  }

  /*** data table options  */
  get options() {
    return {
      accessRights: this.checkBtnRights
    }
  }

  mounted() {
    let rootState = this.$store.state;
    let payload = this.$store.state.dashboard;
    let componentName = "communicationIndex";

    let header = [],
      totalFields,
      fieldsList = [];

    //#.Filter component enabled.
    if (payload.template.filter == true) {
      payload.cards.push("FilterComponent");
      payload.title.push("Filter");
    }

    // @ts-ignore
    _.forOwn(rootState[componentName].fields, function (key, val) {
      if (
        key.primaryKey != true &&
        key.parent != true &&
        key.list != false &&
        key.type != "Hidden"
      ) {
        if (!key.orgTitle) key.orgTitle = key.title;

        if (payload.keyTranslator) key.text = key.orgTitle;
        else key.text = key.title;

        key.title = key.text;
        // @ts-ignore
        header.push(key);
      }

      if (
        !key.primaryKey &&
        key.type != "Hidden" &&
        !key.create &&
        !key.parent
      ) {
        // @ts-ignore
        fieldsList.push(key.value);
      }
    });

    rootState[componentName].headers = header;

    // this.callProposalCallFilter("");

    // @ts-ignore
    this.$store.dispatch("load", this.$store.state["communicationIndex"]);
  }

  editApplication(data) {
    var commId = data.GrantCommunicationId.toString();
        this.$router.push({
            name: "communicationReports",
            params: { communicationId: commId }
        });
  }

  /** check the button rights */
  checkBtnRights(field: any, record: any) {
    switch(field.event){
      case 'delete':
        return false;
        break;
      case 'edit':
        return true;
        break;
      default:
        return true;
    }
  }

  /** Delete Proposal*/
  deleteApplication(data) {
    // handled in parent
    this.$emit('delete', data);
  }

}
